
<template>
  <div class="panel panel-padding">
    <div class="panel-wrap-warrant">
      <div class="warrant-title" style="height:auto">
        <div class="title">工单处理</div>
      </div>
      <div class="warrant-centent">
        <!--	时间选择-->
        <div class="time">
          <div class="time-set" style="width:80%;">
            <div class="select" style="width:220px;height:30px;line-height:30px">
              <span style="width:40px">项目</span>
              <el-select v-model="search.typeid" placeholder="请选择" size="mini" style="width:150px">
                <el-option label="全部" :value="0"></el-option>
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div class="time-one" style="margin-left: 10px;width:300px;">
              <span style="width: 80px;">工单编号</span>
              <el-input v-model="search.orderid" size="mini"></el-input>
            </div>
            <div class="time-one" style="margin-left: 10px;width:300px;">
              <span style="width: 80px;">问题描述</span>
              <el-input v-model="search.keyword" size="mini"></el-input>
            </div>
            <div class="time-one" style="margin-left: 10px;width:300px;">
              <span style="width:80px; height: auto;">提交时间</span>
              <el-date-picker
                style="width:250px"
                v-model="search.betime"
                type="daterange"
                range-separator=" - "
                start-placeholder="起始日期"
                end-placeholder="截止日期"
                value-format="yyyy-MM-dd"
                size="mini"
              ></el-date-picker>
            </div>

            <div class="select" style="margin-left: 20px;width:220px;height:30px;line-height:30px">
              <span style="width:80px">工单状态</span>
              <el-select v-model="search.status" placeholder="请选择" size="mini" style="width:150px">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="buttons">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-search"
              style="width:80px;margin-right:10px;"
              @click="handleSearchClick()"
            >查询</el-button>
          </div>
        </div>
        <div class="table">
          <div class="table-list" style="margin:20px 10px">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              size="mini"
              border
              stripe
              style="width: 100%"
            >
              <el-table-column
                prop="orderid"
                label="工单编号"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="projectType"
                label="项目"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                label="优先级"
                min-width="80"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">{{scope.row.priority|priorityType}}</template>
              </el-table-column>
              <el-table-column
                label="问题分类"
                min-width="80"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">{{scope.row.categoryName}}</template>
              </el-table-column>
              <el-table-column
                prop="question"
                label="问题描述"
                min-width="380"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                label="工单状态"
                min-width="80"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">{{scope.row.status|workStatus}}</template>
              </el-table-column>
              <el-table-column
                prop="createDate"
                label="提交时间"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <!-- <el-table-column
                prop="updateDate"
                label="最新回复时间"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>-->

              <el-table-column fixed="right" label="操作" min-width="120" align="center">
                <template slot-scope="scope">
                  <div class="option-cell">
                    <el-button style="font-size: 12px;" @click="handleReplyClicks(scope.row)">查看</el-button>
                    <el-button
                      v-if="scope.row.status<5"
                      style="font-size: 12px;"
                      @click="handleConfirmedClicks(scope.row.id)"
                    >确认</el-button>
                    <el-button
                      v-if="scope.row.status<5"
                      style="font-size: 12px;"
                      @click="handleAssignClicks(scope.row)"
                    >指派</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handlePageChange"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="search.pageSize"
              :current-page="search.pageNum"
              layout="total, sizes, prev, pager, next"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
      <assign ref="assign" :callback="loadData"></assign>
      <reply ref="reply" :manage="true" :callback="loadData"></reply>
    </div>
  </div>
</template>
<script>
import {
  manageInprocessingList as list,
  manageConfirmed,
  listType
} from "@/api/pay/workorder";
import assign from "@/components/pay/assign";
import reply from "@/components/pay/reply";
export default {
  components: { assign, reply },
  data() {
    return {
      dialogImage: [],
      dialogVisible: false,
      viewVisible: false,
      dialogImageUrl: "",
      formRules: {},
      form: {},
      createFormRulesr: {
        question: [
          { required: true, message: "问题描述不能为空", trigger: "blur" }
        ],
        phone: [{ required: true, message: "手机号不能为空", trigger: "blur" }]
      },
      createForm: {
        priority: 0, //优先级（0一般、1重要）
        question: "",
        privacy: "", //机密信息
        phone: "",
        mail: "",
        receive: 2, //短信接收时间（1、任何时间   2、每日9:00 - 18:00   3、从不接收）
        files: []
      },
      uploadFiles: [],
      dialogTitleser: "提交工单",
      orderShow: false,
      replyDialog: false,
      dialogTitle: "工单处理",
      options: [
        { value: -1, label: "全部" },
        { value: 0, label: "待响应" },
        { value: 1, label: "待您处理反馈" },
        { value: 2, label: "待客户反馈" },
        { value: 5, label: "待客户确认" },
        { value: 7, label: "待客户评价" },
        { value: 9, label: "工单已关闭" }
      ],
      optionsr: [
        { value: 0, label: "一般" },
        { value: 1, label: "紧急" }
      ],
      search: {
        typeid:0,
        orderid: "",
        betime: null,
        keyword: "",
        status: -1,
        pageNum: 1,
        pageSize: 10
      },
      tableData: [],
      typeList: [],
      loading: null,
      total: 0
    };
  },
  filters: {
    priorityType(type) {
      if (type == 0) {
        return "一般";
      } else {
        return "紧急";
      }
    },
    workStatus(status) {
      if (status == 0) {
        return "待响应";
      }
      if (status == 1) {
        return "待您处理反馈";
      }
      if (status == 2) {
        return "待客户反馈";
      }
      if (status == 5) {
        return "待客户确认";
      }
      if (status == 7) {
        return "待客户评价";
      }
      if (status == 9) {
        return "工单已关闭";
      }
      return "";
    }
  },
  created() {
    listType().then(res => {
      this.typeList = res.data.data;
    });
    this.handleSearchClick();
  },
  methods: {
    loadData() {
      let params = Object.assign({}, this.search);
      if (params.betime != null && params.betime.length > 1) {
        params["btime"] = params.betime[0];
        params["etime"] = params.betime[1];
        delete params["betime"];
      }
      list(params).then(res => {
        this.tableData = res.data.data.pageList;
        this.total = res.data.data.total;
      });
    },
    handleSearchClick() {
      this.search.pageNum = 1;
      this.loadData();
    },
    handlePageChange(page) {
      this.search.pageNum = page;
      this.loadData();
    },
    handleSizeChange(size) {
      this.search.pageSize = size;
      this.search.pageNum = 1;
      this.loadData();
    },
    //   工单处理
    handleReplyClicks(row) {
      this.$refs["reply"].handleClick(row.id);
    },
    handleConfirmedClicks(id) {
      this.$confirm(
        "当您确认工单问题已经得到解决，您可提交工单待用户确认（72小时后自动确认），若用户回复工单，您需要继续处理该工单！"
      ).then(() => {
        this.$mLoading.show();
        manageConfirmed(id).then(res => {
          this.$mLoading.close();
          if (res.data.code == "0000") {
            this.loadData();
          } else {
            this.$message.warning(res.data.message);
          }
        });
      });
    },
    handleAssignClicks(row) {
      this.$refs["assign"].handleAssignClick(row.id, this.$store.state.user.id);
    },
    handleRateClicks(id) {},
    //提交
    handleMethodClick() {
      this.replyDialog = false;
    },
    //显示工单弹窗
    handleReferClick() {
      this.$nextTick(() => {
        if (this.$refs.createForm) {
          this.$refs.createForm.clearValidate();
        }
      });
      this.uploadFiles = [];
      this.createForm = {
        priority: 0, //优先级（0一般、1重要）
        question: "",
        privacy: "", //机密信息
        phone: "",
        mail: "",
        receive: 2, //短信接收时间（1、任何时间   2、每日9:00 - 18:00   3、从不接收）
        files: []
      };
      this.orderShow = true;
    },
    //提交工单
    handleTijiaoClick() {
      this.$refs.createForm.validate(valid => {
        if (valid) {
          let formData = new FormData();
          formData.set("priority", this.createForm.priority);
          formData.set("question", this.createForm.question);
          formData.set("privacy", this.createForm.privacy);
          formData.set("phone", this.createForm.phone);
          formData.set("mail", this.createForm.mail);
          formData.set("receive", this.createForm.receive);
          this.createForm.files.forEach(f => {
            formData.append("files", f);
          });
          create(formData).then(res => {
            if (res.data.code == "0000") {
              this.orderShow = false;
              this.$message.success("工单创建成功！");
              console.log(res);
            } else {
              this.$message.warning(res.data.message);
            }
          });
        } else {
          // this.$message.warning("注册信息不完整！");
          return false;
        }
      });
    },
    /**删除 */
    handleRemove(file, list) {
      let files = [];
      list.forEach(f => {
        files.push(f.raw);
      });
      this.createForm.files = files;
      console.log(this.createForm);
    },
    handleExceed(file, list) {
      this.$message.warning("您最多可以上传5个附件");
    },
    handleChange(file, list) {
      let files = [];
      list.forEach(f => {
        files.push(f.raw);
      });
      this.createForm.files = files;
      console.log(this.createForm);
    }
  }
};
</script>

<style>
</style>